import React, { useEffect, useRef, useState } from 'react';
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TestimonialSlider from '../../components/v3/TestimonialSlider/TestimonialSlider';
import TruestedSection from '../../components/v4/TrustedSection/TruestedSection';



import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";

import heroSectionBg from "../../images/v4/aiFeatures/aiPanel/images/heroSectionBg.png";
import heroSectionImgBg from "../../images/v4/aiFeatures/aiPanel/images/heroSectionImgBg.png";
import heroSectionImg2 from "../../images/v4/aiFeatures/aiPanel/images/heroSectionImg2.webp";
import tabsSectionBg from "../../images/v4/aiFeatures/aiPanel/images/tabsSectionBg.png";
import accordianTabsBg from "../../images/v4/aiFeatures/aiChatbot/images/accordianTabsBg.png";
import growingBusinessBg from "../../images/v4/aiFeatures/aiChatbot/images/growingBusinessBg.png";
import flipSectionBg from "../../images/v4/aiFeatures/aiPanel/images/flipSectionBg.png";
import benefitSection1Bg from "../../images/v4/aiFeatures/aiPanel/images/benefitSection1Bg.png";
import faqBg from "../../images/v4/aiFeatures/aiPanel/images/faqBg.png";



import realWorldImg1 from "../../images/v4/aiFeatures/aiPanel/images/realWorldImg1.webp";
import realWorldImg2 from "../../images/v4/aiFeatures/aiPanel/images/realWorldImg2.webp";
import realWorldImg3 from "../../images/v4/aiFeatures/aiPanel/images/realWorldImg3.webp";
import realWorldImg4 from "../../images/v4/aiFeatures/aiPanel/images/realWorldImg4.webp";
import realWorldImg5 from "../../images/v4/aiFeatures/aiPanel/images/realWorldImg5.webp";

import benefitIcon1 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon1.svg";
import benefitIcon2 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon2.svg";
import benefitIcon3 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon3.svg";
import benefitIcon4 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon4.svg";
import benefitIcon5 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon5.svg";
import benefitIcon6 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon6.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import heroIcon1 from "../../images/v4/aiFeatures/aiPanel/icons/heroIcon1.svg";
import heroIcon2 from "../../images/v4/aiFeatures/aiPanel/icons/heroIcon2.svg";
import heroIcon3 from "../../images/v4/aiFeatures/aiPanel/icons/heroIcon3.svg";

import benefit1Icon1 from "../../images/v4/aiFeatures/aiPanel/icons/benefit1Icon1.svg";
import benefit1Icon2 from "../../images/v4/aiFeatures/aiPanel/icons/benefit1Icon2.svg";
import benefit1Icon3 from "../../images/v4/aiFeatures/aiPanel/icons/benefit1Icon3.svg";
import benefit1Icon4 from "../../images/v4/aiFeatures/aiPanel/icons/benefit1Icon4.svg";

import benefit1Img from "../../images/v4/aiFeatures/aiPanel/images/benefit1Img.webp";

import singleCardImg from "../../images/v4/aiFeatures/aiPanel/images/singleCardImg.webp";
import broadcastImg from "../../images/v4/aiFeatures/aiPanel/images/broadcastImg.webp";

import flipImg1 from "../../images/v4/aiFeatures/aiPanel/images/flipImg1.webp";
import flipImg2 from "../../images/v4/aiFeatures/aiPanel/images/flipImg2.webp";
import flipImg3 from "../../images/v4/aiFeatures/aiPanel/images/flipImg3.webp";
import flipImg4 from "../../images/v4/aiFeatures/aiPanel/images/flipImg4.webp";
import flipImg5 from "../../images/v4/aiFeatures/aiPanel/images/flipImg5.webp";



const useStyles = makeStyles((theme) => ({
    commonHeroSection: {
        backgroundImage: `url(${heroSectionBg})`,
        backgroundPosition: "bottom",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
    },
    heroSection: {
        paddingTop: '120px',
        position: "relative",
        marginBottom:'-1px',
        "@media only screen and (max-width: 600px)": {
            paddingTop: '0',
            paddingBottom: '0'
        }
    },
    heroSectionImgSection: {
        backgroundImage: `url(${heroSectionImgBg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        padding: "40px 0",
        marginBottom:'-1px',
        "& img": {
            width: '100%'
        }
    },
    boxes: {
        marginTop: "56px",
        width: '100%',
        display: "flex",
        gap: '24px',
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            marginTop: "20px",
            flexDirection: "column",
            gap: "12px",
        },
    },
    box: {
        gap: "16px",
        width: '20%',
        padding: "24px",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(50px)",
        "& p": {
            width: '100% !important',
        },
        "&:first-child": {
            background: "linear-gradient(180deg, #009A99 0%, #104F4F 50%, #021D1D 100%)",
        },
        "&:nth-child(2)": {
            background: "linear-gradient(180deg, #9E5AD5 0%, #4F1F75 49.52%, #021D1D 100%)",
        },
        "&:last-child": {
            background: "linear-gradient(180deg, #208EEC 0%, #174C79 48.75%, #021D1D 97.5%)",
        },
        "@media only screen and (max-width: 600px)": {
            flex: "1",
            width: '100%',
            padding: "10px",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
        },
    },
    heroSectionContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        margin: '0 auto',
        gap: '24px',
        textAlign: 'center',
        "& h1": {
            width: '70%',

            "@media only screen and (max-width: 600px)": {
                width: '100%'
            }
        },
        "& p": {
            width: '70%',
            "@media only screen and (max-width: 600px)": {
                width: '100%'
            }
        },
        "& span": {
            background:
                "linear-gradient(93deg, #058ED6 4.84%, #00BFA5 99.8%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            display: 'inline-flex',
            alignItems: 'baseline',
            justifyContent: 'flex-start',
            gap: '5px',
            "@media only screen and (max-width: 600px)": {
                "& img": {
                    height: '30px',
                    width: '30px'
                }
            }
        },

    },
    detailSection: {
        background: "linear-gradient(180deg, #210538 0%, #104F4F 100%)",
    },
    detailCard: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        "@media only screen and (max-width: 600px)": {
            flexDirection: "column-reverse",
            gap: "40px",
        },
    },
    detailCardLeft: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "20px",
        width: "38%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            "&.card2": {
                width: "100%",
            },
        },
    },
    detailCardRight: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "20px",
        width: "48%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },
    accordianTabs: {
        backgroundImage: `url(${accordianTabsBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        "& .headercenterContainer": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "64px",
            textAlign: 'center',
            gap: "30px",
            "& h2": {
                width: "100%",
            },
            "& p": {
                width: "100%",
            },
            "@media (max-width:768px)": {
                flexDirection: "column",
                gap: "18px",
                marginBottom: "55px",
                "& h2": {
                    width: "100%",
                },
                "& p": {
                    width: "100%",
                },
            },
        },
    },
    absoulteCard: {
        position: "absolute",
        margin: "0 auto",
        width: "100%",
        top: "-20%",
        "@media only screen and (max-width: 600px)": {
            top: "-16%",
        },
    },
    tabsSection: {
        backgroundImage: `url(${tabsSectionBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        paddingTop: "300px",
        "& .centerContainer": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "90%",
            margin: "0 auto",
            textAlign: "center",
        },
        "& $supportBox": {
            position: "absolute",
            top: "-530px",
            "@media only screen and (max-width: 600px)": {
                top: "-800px",
                marginTop: 0,
            },
        },
        "@media only screen and (max-width: 600px)": {
            paddingTop: "120px",
            "& .centerContainer": {
                width: "100%",
            },
        },
    },
    tabsContainer: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px",
        border: "2px solid #DBDBDB",
        borderRadius: "40px",
        background: "#fff",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "10px",
            padding: "5px",
            overflow: "auto",
            "&::-webkit-scrollbar": {
                display: "none",
            },
        },
    },
    tab: {
        width: "33%",
        background: "",
        padding: "18px",
        background: "transparent",
        borderRadius: "40px",
        background: "transparent",
        transition: "0.3s ease",
        cursor: "pointer",
        "&.active": {
            color: "white",
            background:
                "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
        },
        "@media only screen and (max-width: 600px)": {
            minWidth: "max-content",
            padding: "10px 15px",
        },
    },
    tabCard: {
        marginTop: "65px",
        gap: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        "@media only screen and (max-width: 600px)": {
            marginTop: "30px",
            flexDirection: "column",
        },
    },
    tabCardLeftContainer: {
        width: "50%",
        display: "flex",
        gap: "40px",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        "@media only screen and (max-width: 600px)": {
            gap: "20px",
            width: "100%",
        },
    },
    tabCardRightContainer: {
        width: "50%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },

    tabListContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "30px",
        marginTop: "50px",
        "@media only screen and (max-width: 600px)": {
            gap: "15px",
            marginTop: "20px",
        },
    },
    tabListItem: {
        display: "flex",
        width: "100%",
        margin: "0 auto",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "15px",
        position: "relative",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "15px",
            alignItems: "flex-start",
        },
    },
    tabListItemContent: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "10px",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },
    wpFaq: {
        marginBottom:"-1px",
        "@media only screen and (max-width: 600px)": {
            "& section": {
                padding: "0px 0 0 !important",
            },
        },
    },
    commonPageFooterSection: {
        backgroundColor:'rgba(3, 30, 49, 1)',
        marginBottom:'-1px',
        "& .centerContainer": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "100%",
            margin: "0 auto",
            textAlign: "center",
        },
        "@media only screen and (max-width: 600px)": {
            "& .centerContainer": {
                width: "100%",
            },
        },
    },
    partnerSlide: {
        width: "144px !important",
        "& img": {
            width: "144px",
            filter: "brightness(1)",
        },
        "@media only screen and (max-width: 600px)": {
            width: "max-content !important",
            "& img": {
                width: "100px",
            },
        },
    },
    partnerSlider: {
        padding: "10px 0 60px !important",
        "@media only screen and (max-width: 600px)": {
            paddingBottom: "40px !important",
        },
    },
    growingBusiness: {
        backgroundImage: `url(${growingBusinessBg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        paddingBottom: "80px",
        position: "relative",
        "& .header": {
            width: "55%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            textAlign: "left",
            gap: "32px",
        },
        "& $featureContainer": {
            gap: "20px",
        },
        "@media only screen and (max-width: 600px)": {
            paddingBottom: "50px",
            "& .header": {
                width: "100%",
            },
        },
    },
    broadcastContainerInner: {
        gap: "30px",
        width: "100%",
        display: "flex",
        padding: "0 16rem 0rem 16rem",
        paddingTop: "10px  !important",
        paddingBottom: "10px  !important",
        alignItems: "stretch",
        justifyContent: "flex-start",
        "& swiper-wrapper": {
            alignItems: "stretch !important",
        },

        "& $featureContainer": {
            width: "31%",
            height: "auto  !important",
        },
        "@media only screen and (max-width: 600px)": {
            padding: "0 15px !important",
            paddingBottom: "10px !important",
        },
        "@media only screen and (min-width: 1900px)": {
            paddingLeft: "23rem !important",
            paddingRight: "23rem !important",
        },
    },
    featureContainer: {
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "32%",
        gap: "22px",
        boxShadow: "0px 0px 16px #C1D7DB66",
        borderRadius: "16px",
        background: "#fff",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        textAlign: "left",
        "& p": {
            width: "90%",
        },
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            "& p": {
                width: "100%",
            },
        },
    },
    trustedSection: {
        "& .trustedHeading": {
            textAlign: 'center'
        }
    },
    benefitSection1: {

        backgroundImage: `url(${benefitSection1Bg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        background: "#F7F1FB",
        paddingTop: '310px',
        marginBottom:'-1px',
        "& .centerContainer": {
            width: '80%',
            display: "flex",
            justifyContent: "center",
            gap: "32px",
            flexDirection: 'column',
            alignItems: 'center',
            margin: "0 auto",
            textAlign: "center",
            "& h2": {
                flex: 1,
            },
            "& p": {
                flex: 1,
            },
        },
        "@media only screen and (max-width:  768px)": {
            "& .centerContainer": {
                flexDirection: "column",
                width: '100%'
            },
        },

        "& .benefits": {
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            margin: "60px 0",
            marginBottom: '0',
            "& .imageColumn": {
                width: "94.5%",

                "& img": {
                    width: "100%",
                },
            },

            "& .featureColumn": {
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                width: "92%",
                "& .featureContainer": {
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    width: "100%",
                    gap: "22px",
                    boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.15)",
                    borderRadius: "16px",
                    background: "rgba(158, 90, 213, 0.20)",
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    textAlign: "left",
                    marginBottom: "0",
                    minHeight: "48%",
                    "& p": {
                        // color: $black2,
                        width: "90%",
                    },
                    "@media only screen and (max-width: 600px)": {
                        width: "100%",
                        minHeight: "0",
                        "& p": {
                            width: "100%",
                        },
                    },
                },
            },

            "@media only screen and (max-width:  768px)": {
                flexDirection: "column",
                gap: "20px",
                marginBottom: "0",

                "& .imageColumn": {
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                },

                "& .featureColumn": {
                    width: "100%",
                },
            },
        },
    },

    //tabscards
    cardTabsSection: {
        background: "linear-gradient(180deg, #011C33 0%, #210538 100%)",
        "& .header": {
            display: 'flex',
            marginBottom: '64px',
            width: '100%',
            "& span": {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: '5px',
                "@media only screen and (max-width: 600px)": {
                    "& img": {
                        height: '30px',
                        width: '30px'
                    }
                }
            }
        }
    },
    cardTabsContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '24px',
        width: '100%'
    },
    cardTabsSelectors: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '30px',
        "@media only screen and (max-width: 600px)": {
            overflow: 'auto',
            gap: '15px',
            justifyContent: 'flex-start',
            "&::-webkit-scrollbar": {
                display: "none",
            },
        }
    },
    cardTabsSelector: {
        background: "rgba(255, 255, 255, 0.10)",
        padding: '24px',
        width: '32%',
        borderRadius: '16px',
        color: '#fff',
        opacity: '0.5',
        transition: '0.3s ease',
        border: '2px solid transparent',
        cursor: 'pointer',
        textAlign: 'center',
        "&.active": {
            opacity: '1',
            background: 'linear-gradient(105deg, rgba(77, 0, 140, 0.50) 0%, rgba(181, 93, 251, 0.50) 100%)',
            border: '2px solid rgba(255, 255, 255, 0.50)',
        },
        "@media only screen and (max-width: 600px)": {
            width: 'max-content',
            minWidth: "max-content",
            padding: '12px 8px',
            borderWidth: '1px',
            borderRadius: '6px',
            "&.active": {
                borderWidth: '1px',
            }

        }
    },
    cardTab: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: "24px 64px",
        borderRadius: '12px',
        background: "linear-gradient(105deg, rgba(77, 0, 140, 0.50) 0%, rgba(181, 93, 251, 0.50) 100%)",
        "@media only screen and (max-width: 600px)": {
            padding: '20px',
            flexDirection: 'column'
        }
    },
    cardTabLeft: {
        width: '30%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '16px',
        "@media only screen and (max-width: 600px)": {
            width: '100%'
        }
    },
    cardTabRight: {
        width: '65%',
        "@media only screen and (max-width: 600px)": {
            width: '100%'
        }
    },
    //tabscards

    //hovercards

    hoverCardSection: {
        background: 'linear-gradient(180deg, #021D1D 0%, #011C33 100%)',
        "& .header": {
            display: 'flex',
            marginBottom: '64px',
            width: '100%',
            gap: '32px',
            flexDirection: 'column',
            "& h2": {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: '5px'
            },
            "& p": {
                width: '80%'
            },
            "@media only screen and (max-width: 600px)": {
                marginBottom: '40px',
            }
        }
    },

    hoverCardContianer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '30px',
        "@media only screen and (max-width: 600px)": {
            flexDirection: 'column',
            gap: '20px'
        }
    },

    hoverCard: {
        background: "linear-gradient(105deg, rgba(10, 47, 79, 0.35) 0%, rgba(37, 118, 187, 0.35) 100%)",
        padding: '16px 24px',
        width: '32%',
        gap: '24px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        borderRadius: '12px',
        opacity: '0.5',
        transition: '0.3s ease',
        cursor: 'pointer',
        textAlign: 'left',
        transform: 'scale(1)',
        "&:hover": {
            transform: 'scale(1.1)',
            opacity: '1',
            // padding: '28px 24px',
            background: 'linear-gradient(105deg, #0A2F4F 0%, #2576BB 100%)',
        },
        "@media only screen and (max-width: 600px)": {
            width: '100%',
            "&:hover": {
                transform: 'scale(1)',
            }
        }
    },

    cardsSection: {
        background: '#021D1D',
        paddingTop: '280px',
        "& .cardImg": {
            "& img": {
                width: '100%',
                height: '100%'
            }
        },
        "@media only screen and (max-width: 600px)": {
            "& .cardImg": {
                width: '100%',
                height: '100%',
                marginBottom: "15px",
                marginTop: "0",
                "& img": {
                    width: '100%',
                    height: '100%'
                }
            }
        }
    },
    belowText: {
        width: "100%",
        textAlign: "right",
        color: "#6691b7",
        marginTop: "20px",
    },

    //hovercards


    singleCardDetailsSection: {
        background: '#021D1D',
        position: 'relative',
        paddingBottom: '220px',
        "@media only screen and (max-width: 600px)": {
            paddingBottom: '380px'
        }
    },
    singleCardDetails: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '20px',
        "@media only screen and (max-width: 600px)": {
            flexDirection: 'column'
        }
    },
    singleCardDetailsLeft: {
        width: '55%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        gap: '15px',
        "@media only screen and (max-width: 600px)": {
            width: '100%'
        }
    },
    singleCardDetailsRight: {
        width: '45%',
        "@media only screen and (max-width: 600px)": {
            width: '100%'
        }
    },
    singleCardDetailsRightImage: {
        width: '100%'
    },

    supportBox: {
        top: "90%",
        marginTop: "60px",
        width: "100%",
        display: "flex",
        padding: "40px",
        position: "absolute",
        background: "linear-gradient(90deg, #00266D 0%, #00B39B 100%)",
        // backgroundImage: `url(${benefitBgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        alignItems: "center",
        borderRadius: "20px",
        backdropFilter: "blur(30px)",
        justifyContent: "space-between",
        "& $broadcastLeftContainer": {
            width: "45%",
            "@media only screen and (max-width: 860px)": {
                width: "100%",
            },
        },
        "@media only screen and (max-width: 860px)": {
            flexDirection: "column",
            width: "94%",
            padding: "15px",
            marginTop: "20px",
            gap: "20px",
            top: '100%'
        },
    },

    broadcastLeftContainer: {
        width: "55%",
        "@media only screen and (max-width: 860px)": {
            width: "100%",
        },
    },
    broadcastRightContainer: {
        width: "40%",
        "@media only screen and (max-width: 860px)": {
            width: '100%'
        }
    },

    zigZagSection: {
        background: "#011C33",
        marginBottom:'-1px'
    },

    zigZagContainer: {
        gap: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         "@media only screen and (max-width: 860px)": {
            flexDirection: 'column'
        }
    },

    zigZagLeftContainer: {
        gap: '15px',
        width: '45%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        "@media only screen and (max-width: 860px)": {
            width: '100%'
        }
    },
    zigZagRightContainer: {
        gap: '15px',
        width: '45%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        "@media only screen and (max-width: 860px)": {
            width: '100%'
        }
    },
    zigZagBgCard:{
        padding:"1px",
        width: '48%',
        background:'linear-gradient(180deg,rgba(29, 111, 182, 1) 0%, rgba(206, 233, 255, 0.20) 100%)',
        borderRadius: '16px',
        position: 'relative',
        "&:nth-child(2)": {
            top: '20px',
        },
        "&:nth-child(4)": {
            top: '20px',
        },
        "@media only screen and (max-width: 400px)": {
            width: "100%",
            "&:nth-child(2)": {
                top: "0px",
            },
            "&:nth-child(4)": {
                top: "0px",
            },
        },
    },

    zigZagBox: {
        width: '100%',
        height:'100%',
        gap: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        background: 'rgba(1, 28, 51, 1)',
        padding: '32px 24px',
        justifyContent: 'flex-start',
        position: 'relative',
        backdropFilter: "blur(32px)",
        borderRadius: '16px',
        overflow: 'hidden',
        "&.regularCard": {
            // background: "rgba(0, 44, 81, 0.4)",
            "&.glass-effect": {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "100px",
                    height: "100px",
                    zIndex: "-1",
                    background: "radial-gradient(circle, #B458FF 100%)",
                    borderRadius: "50%",
                    filter: "blur(80px)",
                    opacity: "var(--before-opacity, 0)",
                    left: "var(--before-left, 0)",
                    top: "var(--before-top, 0)",
                    transition: "opacity 0.3s ease",
                    pointerEvents: "none",
                },
            },
        },
    },

    glowTop: {
        position: 'absolute',
        width: '150%',
        height: '30px',
        background: 'radial-gradient(circle, rgba(29, 111, 182, 0.9) 0%, rgba(29, 111, 182, 0) 70%)',
        borderRadius: '10%',
        filter: 'blur(30px)',
        top: '-10px',
        left: '50%',
        transform: 'translateX(-50%)',
        pointerEvents: 'none',
        zIndex: '0',
    },

    glowBottom: {
        position: 'absolute',
        width: '180px',
        height: '180px',
        background: 'radial-gradient(circle, rgba(29, 111, 182, 0.9) 0%, rgba(29, 111, 182, 0) 70%)',
        borderRadius: '50%',
        filter: 'blur(40px)',
        bottom: '-100px',
        left: '-30px',
        pointerEvents: 'none',
        zIndex: '-1',
    },

    //flip section

    flipSection: {
        paddingBottom: "260px",
        backgroundPosition: "top",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundImage: `url(${flipSectionBg})`,
        "& .centerContainer": {
            width: "80%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            margin: "0 auto",
            textAlign: "center",
            "@media only screen and (max-width: 600px)": {
                width: "100%",
            },
        },
        "& #flipCardsSection .card": {
            top: "280px",
            zIndex: 2,
            "@media only screen and (max-width: 600px)": {
                top: "240px",
            },
        },
        "& #flipCardsSection .cardImg": {
            height: "420px",
            overflow: "hidden",
            "& img": {
                height: "100%",
                width: "100%",
                objectFit: "contain",
                objectPosition: "bottom",
            },
            "@media only screen and (max-width: 600px)": {
                height: "220px",
                width: "100%",
            },
        },
        "& #flipCardsSection .transparentButton": {
            "@media only screen and (max-width: 600px)": {
                padding: "10px 16px",
                fontSize: "13px",
            },
        },
        "& .trustedHeading": {
            width: "80%",
            textAlign: "center",
            margin: "0 auto",
            "@media only screen and (max-width: 600px)": {
                width: "100%",
            },
        },
        "@media only screen and (max-width: 600px)": {
            paddingBottom: '200px'
        }
    },
    tabs: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
        justifyContent: "center",
        width: "fit-content",
        margin: "48px auto",
        position: "sticky",
        top: "140px",
        zIndex: 1,
        padding: "12px 20px",
        borderRadius: "20px",
        marginBottom: "60px",
        "@media only screen and (max-width: 600px)": {
            flexWrap: "nowrap",
            overflowX: "auto",
            width: "calc(100% - 40px)",
            marginBottom: "32px",
            justifyContent: "flex-start",
             padding: "12px 0px",
        },
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
    tabsScrolling: {
        position: "relative",
        top: "auto",
    },
    flipTopHeader: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: "0 auto",
        textAlign: "center",
    },
    fliptab: {
        cursor: "pointer",
        width: "max-content",
        padding: "14px 28px",
        alignItems: "center",
        borderRadius: "14px",
        transition: "0.3s ease",
        border: "1px solid rgba(255, 255, 255, 0.50)",
        "&.active": {
            background: "#FF682A",
            border: "1px solid #FF682A",
            "& p": {
                fontWeight: '600',
            }
        },
        "@media only screen and (max-width: 768px)": {
            minWidth: "max-content",
            padding: "8px 12px",
            borderRadius: "10px",
            "& p": {
                fontSize: "13px",
            },
        },
    },
    flipCard: {
        background: "#fff",
        borderRadius: "32px",
        padding: '40px',
        overflow: "hidden",
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        "@media only screen and (max-width: 600px)": {
            flexDirection: "column",
            padding: '20px',
            gap: '20px'
        },
    },
    flipCardLeft: {
        width: "50%",
        display: "flex",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            paddingTop: "0px",
        },
    },
    flipCardRight: {
        width: "50%",
        display: "flex",
        flexDirection: "column",
        gap: "40px",
        alignItems: "center",
        justifyContent: "flex-start",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "20px",
        },
    },
    flipCardRightHeader: {
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "100%",
    },
    flipCardPointers: {
        display: "flex",
        gap: "40px",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "100%",
    },
    flipCardPointer: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "45%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },

    //flip section


}));

const AiPanel = () => {

    // desclaration
    const classes = useStyles();
    const [activeRealWorld, setActiveRealWorld] = useState(0);
    const [cardTabSelector, setCardTabSelector] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);
    const [tabsPastCards, setTabsPastCards] = useState(false);
    const isManualScroll = useRef(false);

    useEffect(() => {
        const section = document.getElementById("flipCardsSection");
        if (!section) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                    setTabsPastCards(true);
                } else {
                    setTabsPastCards(false);
                }
            },
            { threshold: 0 }
        );
        observer.observe(section);
        return () => observer.disconnect();
    }, []);

    //scrollableCards
    useEffect(() => {
        const cards = document.querySelectorAll("#flipCardsSection .card");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const card = entry.target;
                    const currentIndex = Array.from(cards).indexOf(card);

                    const updateClasses = (activeIdx) => {
                        cards.forEach((c) => {
                            c.classList.remove("is-previous-1", "is-previous-2", "is-previous-3", "is-previous-4");
                        });
                        cards.forEach((c, idx) => {
                            if (idx < activeIdx) {
                                const difference = activeIdx - idx;
                                if (difference <= 4) {
                                    c.classList.add(`is-previous-${difference}`);
                                }
                            }
                        });
                    };

                    if (!isManualScroll.current) {
                        if (entry.isIntersecting) {
                            setActiveIndex(currentIndex);
                            updateClasses(currentIndex);
                        } else if (!entry.isIntersecting && entry.boundingClientRect.top > 0 && currentIndex > 0) {
                            setActiveIndex(currentIndex - 1);
                            updateClasses(currentIndex - 1);
                        }
                    }
                });
            },
            { root: null, threshold: 0.3, rootMargin: "0px" }
        );

        cards.forEach((card) => observer.observe(card));
        return () => observer.disconnect();
    }, []);
    //scrollableCards

    // flip cards

    // glowing effect

    useEffect(() => {
        // Select all cards that should have the effect
        const cardsToAnimate = [
            ...document.querySelectorAll(`.${classes.zigZagBox}.regularCard`), // Add regularCards

        ];

        cardsToAnimate.forEach((card) => {
            if (!card) return;

            card.classList.add("glass-effect");

            // Set initial top-right position for the glass effect
            const setInitialPosition = () => {
                const rect = card.getBoundingClientRect();
                const topRightX = rect.width - 150; // Adjust this value to position from right edge
                const topRightY = 0; // Top position

                card.style.setProperty("--before-left", `${topRightX}px`);
                card.style.setProperty("--before-top", `${topRightY}px`);
                card.style.setProperty("--before-opacity", "0.8");
            };

            // Call it initially
            setInitialPosition();

            let lastX = null;
            let lastY = null;

            const handleMouseMove = (e) => {
                const rect = card.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;

                lastX = x;
                lastY = y;

                card.style.setProperty("--before-left", `${x - 75}px`);
                card.style.setProperty("--before-top", `${y - 75}px`);
            };

            const handleMouseEnter = () => {
                if (lastX !== null && lastY !== null) {
                    card.style.setProperty("--before-left", `${lastX - 75}px`);
                    card.style.setProperty("--before-top", `${lastY - 75}px`);
                }
                card.style.setProperty("--before-opacity", "0.8");
            };

            const handleMouseLeave = () => {
                card.style.setProperty("--before-opacity", "0.8");
            };

            // Store handlers on the card element for cleanup
            card.handlers = {
                mousemove: handleMouseMove,
                mouseenter: handleMouseEnter,
                mouseleave: handleMouseLeave,
                resize: setInitialPosition,
            };

            // Add event listeners
            card.addEventListener("mousemove", handleMouseMove);
            card.addEventListener("mouseenter", handleMouseEnter);
            card.addEventListener("mouseleave", handleMouseLeave);
            window.addEventListener("resize", setInitialPosition);
        });

        // Cleanup
        return () => {
            cardsToAnimate.forEach((card) => {
                if (!card) return;

                const handlers = card.handlers;
                if (handlers) {
                    card.removeEventListener("mousemove", handlers.mousemove);
                    card.removeEventListener("mouseenter", handlers.mouseenter);
                    card.removeEventListener("mouseleave", handlers.mouseleave);
                    window.removeEventListener("resize", handlers.resize);
                }
            });
        };
    }, [classes]);

    // glowing effect


    // data

    const tabContentData = [
        {
            tabContent: [
                {
                    title: "Quick lead updates",
                    content: "Add or edit contact details instantly with simple AI-powered commands.",
                    alt: "AI CRM for Sales Teams",
                },
                {
                    title: "Prompt next steps",
                    content: "Get real-time AI suggestions to take timely, impactful actions on deals.",
                    alt: "AI CRM for Sales Teams",
                },
                {
                    title: "Deal history view",
                    content: "Instantly access all previous interactions, calls, and updates in one place.",
                    alt: "AI CRM for Sales Teams",
                },
                {
                    title: "Auto task tracking",
                    content: "AI automatically sets reminders and tracks follow-ups to avoid delays.",
                    alt: "AI CRM for Sales Teams",
                },
            ],
            img: realWorldImg1,
            alt: "AI CRM for Sales Teams",
            subtitle:
                "Helps sales reps manage leads, follow up promptly, and keep opportunities moving with less manual effort.",
        },
        {
            tabContent: [
                {
                    title: "Smart segmentation",
                    content: "Group leads based on interests, behaviour, and campaign engagement patterns.",
                    alt: "AI CRM for Marketing Teams",
                },
                {
                    title: "Campaign prompts",
                    content: "AI recommends messaging strategies based on past campaign and audience behaviour.",
                    alt: "AI CRM for Marketing Teams",
                },
                {
                    title: "Trend analysis",
                    content: "Track campaign results to identify high-performing segments and outreach tactics.",
                    alt: "AI CRM for Marketing Teams",
                },
                {
                    title: "Easy tracking",
                    content: "Monitor every campaign stage with complete visibility into performance metrics.",
                    alt: "AI CRM for Marketing Teams",
                },
            ],
            img: realWorldImg2,
            alt: "AI CRM for Marketing Teams",
            subtitle:
                "Empowers marketing to segment audiences, personalise outreach, and launch campaigns that convert more efficiently.",
        },
        {
            tabContent: [
                {
                    title: "Fast call logs",
                    content: "Log support conversations and notes quickly without toggling between CRM tabs.",
                    alt: "AI CRM for Support Teams",
                },
                {
                    title: "Follow-up alerts",
                    content: "Automated task reminders help agents stay proactive and never miss follow-ups.",
                    alt: "AI CRM for Support Teams",
                },
                {
                    title: "Ticket search",
                    content: "Easily locate historical support cases using smart CRM search and filters.",
                    alt: "AI CRM for Support Teams",
                },
                {
                    title: "Context-driven help",
                    content: "View entire interaction histories to respond accurately and resolve faster.",
                    alt: "AI CRM for Support Teams",
                },
            ],
            img: realWorldImg3,
            alt: "AI CRM for Support Teams",
            subtitle: "Enables agents to log interactions, track tickets, and respond to customers with precision and speed.",
        },

        {
            tabContent: [
                {
                    title: "Pipeline snapshots",
                    content: "View real-time deal stages, values, and bottlenecks at a glance.",
                    alt: "AI CRM for Business Leaders",
                },
                {
                    title: "Performance patterns",
                    content: "Identify top-performing reps, trends, and areas needing improvement instantly.",
                    alt: "AI CRM for Business Leaders",
                },
                {
                    title: "Predictive views",
                    content: "AI forecasts deal outcomes using past performance and engagement data.",
                    alt: "AI CRM for Business Leaders",
                },
                {
                    title: "Instant summaries",
                    content: "Quickly generate high-level reports to support faster decision-making and planning.",
                    alt: "AI CRM for Business Leaders",
                },
            ],
            img: realWorldImg4,
            alt: "AI CRM for Business Leaders",
            subtitle: "Gives leadership real-time insights into pipelines, team performance, and emerging trends to make data-driven decisions.",
        },
        {
            tabContent: [
                {
                    title: "Mobile updates",
                    content: "Add leads, log calls, and set tasks anytime from mobile devices.",
                    alt: "AI CRM for Remote Teams",
                },
                {
                    title: "AI reminders",
                    content: "Receive smart nudges and alerts so you never miss key actions.",
                    alt: "AI CRM for Remote Teams",
                },
                {
                    title: "History on hand",
                    content: "Access full customer records before meetings or client interactions.",
                    alt: "AI CRM for Remote Teams",
                },
                {
                    title: "Keep selling",
                    content: "Move deals forward from anywhere, in the field or remotely.",
                    alt: "AI CRM for Remote Teams",
                },
            ],
            img: realWorldImg5,
            alt: "AI CRM for Remote Teams",
            subtitle: "Supports teams on the move by bringing full AI-powered CRM features right to their mobile devices.",
        },
    ];

    const benefits = [
        {
            title: "Built-in AI sentiment analysis",
            desc: "Turns closed conversations into insights you can act on immediately. No switching tabs, no extra effort.",
            icon: benefitIcon1,
        },
        {
            title: "Trusted by SMEs",
            desc: "Trusted CRM for fast-growing small and mid-sized businesses across industries. Used by teams that value clarity and speed.",
            icon: benefitIcon2,
        },
        {
            title: "Easy to use",
            desc: "Intuitive design that helps your team work faster and stay focused. Every feature is built to support daily workflows.",
            icon: benefitIcon3,
        },
        {
            title: "SME-friendly pricing",
            desc: "Affordable AI tools that deliver practical results without bloated pricing. Perfect for SME budgets.",
            icon: benefitIcon4,
        },
        {
            title: "All-in-one CRM",
            desc: "Complete CRM that merges automation, data, and emotional intelligence. Everything you need to grow in one place.",
            icon: benefitIcon5,
        },
        {
            title: "Privacy first",
            desc: "Privacy- Keeps customer data secure and compliant always. Built with care, scaled with confidence.",
            icon: benefitIcon6,
        },
    ];

    const partners = [
        { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
        { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
        { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
        { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
        {
            icon: partnerIcon6,
            alt: "mustard seed systems corporation - Pepper Cloud Customer",
        },
        {
            icon: partnerIcon7,
            alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
        },
        { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
        { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
        { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
        { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
        { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
        {
            icon: partnerIcon6,
            alt: "mustard seed systems corporation - Pepper Cloud Customer",
        },
        {
            icon: partnerIcon7,
            alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
        },
        { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    ];

    const faqs = [
        {
            question: "What is the AssistAI panel in Pepper Cloud CRM?",
            answer:
                "It is an advanced AI assistant panel built into Pepper Cloud, combining agentic AI and assistive AI. It lets you perform CRM actions, get insights, and manage workflows by simply typing natural commands.",
        },
        {
            question: "How does the AssistAI panel work?",
            answer:
                "The AssistAI panel uses conversational AI to understand your typed prompts. Whether you want to create a lead, log a call, or pull up a report, it processes your request instantly, just like talking to a smart sales colleague.",
        },
        {
            question: "What types of tasks can the AssistAI panel handle?",
            answer:
                "It can create leads, contacts, accounts, opportunities, add notes, log calls, send emails, set reminders, and even fetch data from your CRM. It is your always-available AI agent for day-to-day CRM operations.",
        },
        {
            question: "Do I need admin access to use the AssistAI panel?",
            answer:
                "No. Both standard and admin users can use it. The panel respects your CRM permissions, so users only perform actions allowed by their role.",
        },
        {
            question: "Is the AssistAI panel secure for sensitive customer data?",
            answer:
                "Absolutely. Pepper Cloud’s AI CRM follows strict encryption and access controls. Your data stays private, secure, and only accessible as per your organisation’s role settings.",
        },
        {
            question: "Can the AssistAI panel help automate follow-ups?",
            answer:
                "Yes. It can create smart follow-up tasks, reminders, and even prompt your team when it is time to reach out, reducing missed opportunities.",
        },
        {
            question: "Is it like a typical chatbot?",
            answer:
                "Not quite. It goes beyond simple chat. The AssistAI panel is powered by generative AI and agentic AI, which means it actively handles tasks and suggests next steps based on your CRM data.",
        },
        {
            question: "How does the AssistAI panel save time for teams?",
            answer:
                "By eliminating manual data entry, searching through records, and repetitive updates. Teams often save 20+ hours a month that they can now spend on selling or supporting customers.",
        },
        {
            question: "Does the AssistAI panel work on mobile?",
            answer:
                "Yes. You can access all its features via Pepper Cloud’s mobile CRM. This means you can create leads, log activities, and use AI prompts even when on the go.",
        },
        {
            question: "What happens if I hit my prompt limit?",
            answer:
                "Pepper Cloud uses a credit-based system for AssistAI usage. Once you reach your prompt quota, you can easily top up to continue leveraging your AI assistant without interruption.",
        },
    ];

    const flipCards = [
        {
            tab: "Stay organised",
            background: "linear-gradient(180deg, #783CA8 0%, #09939A 100%)",
            img: flipImg1,
            alt: "AI Assistant for sales and CRM automation",
            heading: "Stay organised without extra effort",
            desc: "Use the AssistAi Panel to add notes, log calls, create tasks, or send emails — all linked neatly to the right record. No more switching screens or losing track of crucial details. This means your entire team stays aligned, follows a clear process, and never risks letting a key follow-up slip through the cracks.",
            points: [
                {
                    heading: "Instant actions",
                    desc: "Add or update leads, contacts, accounts, and deals with a single prompt — no manual data entry required.",
                },
                {
                    heading: "Natural commands",
                    desc: "Use everyday language, and the AI agent intelligently understands what you want done.",
                },
                {
                    heading: "Always available",
                    desc: "Get help with any sales task 24/7, boosting responsiveness and freeing your team’s time.",
                },
            ],
        },
        {
            tab: "Automate follow-ups",
            background: "linear-gradient(359deg, #0A2F4F 1.01%, #2576BB 99.32%)",
            img: flipImg2,
            heading: "Automate follow-ups with intelligent workflows",
            desc: "Set smart reminders, trigger personalised nudges, and let artificial intelligence prompt you exactly when action is needed. You can be sure no deal stalls due to missed tasks or delayed responses. This also keeps your sales process proactive, so leads feel valued and conversations never go cold.",
            alt: "CRM assistant for process and teamwork",
            points: [
                {
                    heading: "Linked records",
                    desc: "Automatically associate every note, call, or email with the right contact, lead, or opportunity.",
                },
                {
                    heading: "Unified workspace",
                    desc: "Do it all from one place without toggling between screens or losing information.",
                },
                {
                    heading: "Team alignment",
                    desc: "Everyone follows the same process — nothing slips through the cracks.",
                },
            ],
        },
        {
            tab: "AI-powered CRM",
            background: "linear-gradient(180deg, #00B39B 0%, #00266D 100%)",
            img: flipImg3,
            alt: "AI-powered workflow and CRM automation",
            heading: "Experience a true AI-powered CRM",
            desc: "Beyond the AssistAi Panel, Pepper Cloud’s CRM merges powerful AI agents with live dashboards and smart automation. It predicts next best actions, strengthens pipeline health, and guides decisions with real-time insights — helping your team close more deals confidently, with far less guesswork.",
            points: [
                {
                    heading: "Intelligent nudges",
                    desc: "Get prompted when to follow up, reply, or take the next step — so deals don’t stall.",
                },
                {
                    heading: "Smart automation",
                    desc: "Let the AI assistant automate reminders and send timely nudges to the right team members.",
                },
                {
                    heading: "Scalable and proactive",
                    desc: "Works across teams of any size, keeps your pipeline warm, and ensures consistent customer engagement.",
                },
            ],
        },
        {
            tab: "Conversational AI",
            background: "linear-gradient(180deg, #009A99 0%, #053333 100%)",
            img: flipImg4,
            alt: "AI-powered CRM platform and dashboards",
            heading: "Scale confidently with conversational AI",
            desc: "Whether your team is two or two hundred, our AI assistants scale seamlessly. They learn from your workflows and adapt to your processes, ensuring everyone stays productive, follows best practices, and engages customers effectively, without drowning in admin work that hinders growth.",
            points: [
                {
                    heading: "Predictive insights",
                    desc: "Let AI forecast next best steps and provide actionable recommendations, so your pipeline stays healthy.",
                },
                {
                    heading: "Live dashboards",
                    desc: "Monitor every metric and workflow in real-time for informed, data-driven decisions.",
                },
                {
                    heading: "Less guesswork",
                    desc: "Rely on AI guidance to move deals forward, reduce uncertainty, and empower your entire team.",
                },
            ],
        },
        {
            tab: "Work smarter",
            background: "linear-gradient(180deg, #783CA8 0%, #09939A 100%)",
            img: flipImg5,
            alt: "Conversational AI scalability",
            heading: "Work smarter with advanced AI assistants",
            desc: "Create or update leads, contacts, accounts, and opportunities in seconds by simply typing a natural command. For example, say “Add a new contact for Jane at ABC Corp,” and your AI agent does the rest. It is like having an always-on assistant ready to take action on your sales tasks.",
            points: [
                {
                    heading: "Seamless scalability",
                    desc: "Adaptable AI agents that work for any team size, ensuring every user is empowered.",
                },
                {
                    heading: "Learns your processes",
                    desc: "AI learns from your workflows and guides new users to follow proven best practices.",
                },
                {
                    heading: "Enable growth",
                    desc: "Let your team focus on customers and sales, while the AI handles repetitive admin work.",
                },
            ],
        },
    ];



    return (
        <main>
            <SEO
                title={
                    "AI assistant panel: best AI CRM assistant | Pepper Cloud"
                }
                pathname={
                    "https://peppercloud.com/best-ai-crm-features/ai-chatbot-for-crm/"
                }
                keywords="Best AI assistant, AI virtual assistant, CRM with AI assistant, AI Assistant, AssistAI Panel"
                description={"Boost productivity with Pepper Cloud AssistAI panel. The best AI assistant for CRM. Automate tasks, get insights, and close deals faster."}
                ogData={{
                    "og:image": [
                        "/meta/og/1X1/home.png",
                        "/meta/og/1024X512/home.png",
                        "/meta/og/1200X630/home.png",
                    ],
                }}
                jsonLd={[
                    {
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        name: "Pepper Cloud",
                        legalName: "Pepper Cloud PTE LTD",
                        url: "https://peppercloud.com/",
                        logo: "https://peppercloud.com/icons/logo.png",
                        foundingDate: "2017",
                        address: [
                            {
                                "@type": "PostalAddress",
                                streetAddress: "#04-01/02",
                                addressLocality: "Blk 79 Ayer Rajah Crescent",
                                addressRegion: "SG",
                                postalCode: "139955",
                                addressCountry: "Singapore",
                            },
                            {
                                "@type": "PostalAddress",
                                streetAddress:
                                    "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                                addressLocality: "Bengaluru",
                                addressRegion: "KA",
                                postalCode: "560095",
                                addressCountry: "India",
                            },
                        ],
                        contactPoint: {
                            "@type": "ContactPoint",
                            contactType: "customer support",
                            telephone: "+6566562616",
                            email: ["sales@peppercloud.com", "support@peppercloud.com"],
                        },
                        sameAs: [
                            "https://twitter.com/peppercloudpte",
                            "https://www.linkedin.com/company/peppercloud/",
                            "https://www.facebook.com/PepperCloudPteLtd",
                            "https://www.instagram.com/pepper.cloud/",
                        ],
                    },
                    {
                        "@context": "https://schema.org",
                        "@type": "VideoObject",
                        name: "AssistAI",
                        description:
                            "Harness the power of Pepper Cloud's AssistAI to simplify conversations, automate tasks, streamline workflows, and more. Save time, improve productivity, and make smarter sales decisions with the best AI CRM for your sales workflow.",
                        thumbnailUrl: [
                            "https://drive.google.com/file/d/11D38QAsWjwxtUae6YnwdP1Y__tusgmRF/view?usp=drive_link",
                        ],
                        uploadDate: "2024-12-02",
                        contentUrl:
                            "https://peppercloud.com/static/aiPageHeroSection-3907c41f7c08dfe21633f203852eebe2.mp4",
                        publisher: {
                            "@type": "Organization",
                            name: "Pepper Cloud",
                            logo: {
                                "@type": "ImageObject",
                                url: "https://d4.alternativeto.net/TylnV9uYJt3KRkoH7m9Qbm-T2kdjqV4X3JgKsTxbTUs/rs:fit:280:280:0/g:ce:0:0/exar:1/YWJzOi8vZGlzdC9pY29ucy9wZXBwZXItY2xvdWQtY3JtXzI0MzM4NS5wbmc.png",
                                width: "",
                                height: "",
                            },
                        },
                        duration: "PT1M12S",
                    },
                    {
                        "@context": "https://schema.org/",
                        "@type": "FAQPage",
                        mainEntity: [
                            {
                                "@type": "Question",
                                "name": "What is the AssistAI panel in Pepper Cloud CRM?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "It is an advanced AI assistant panel built into Pepper Cloud, combining agentic AI and assistive AI. It lets you perform CRM actions, get insights, and manage workflows by simply typing natural commands."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "How does the AssistAI panel work?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "The AssistAI panel uses conversational AI to understand your typed prompts. Whether you want to create a lead, log a call, or pull up a report, it processes your request instantly, just like talking to a smart sales colleague."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "What types of tasks can the AssistAI panel handle?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "It can create leads, contacts, accounts, opportunities, add notes, log calls, send emails, set reminders, and even fetch data from your CRM. It is your always-available AI agent for day-to-day CRM operations."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Do I need admin access to use the AssistAI panel?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "No. Both standard and admin users can use it. The panel respects your CRM permissions, so users only perform actions allowed by their role."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Is the AssistAI panel secure for sensitive customer data?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Absolutely. Pepper Cloud’s AI CRM follows strict encryption and access controls. Your data stays private, secure, and only accessible as per your organisation’s role settings."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Can the AssistAI panel help automate follow-ups?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Yes. It can create smart follow-up tasks, reminders, and even prompt your team when it is time to reach out, reducing missed opportunities."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Is it like a typical chatbot?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Not quite. It goes beyond simple chat. The AssistAI panel is powered by generative AI and agentic AI, which means it actively handles tasks and suggests next steps based on your CRM data."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "How does the AssistAI panel save time for teams?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "By eliminating manual data entry, searching through records, and repetitive updates. Teams often save 20+ hours a month that they can now spend on selling or supporting customers."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Does the AssistAI panel work on mobile?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Yes. You can access all its features via Pepper Cloud’s mobile CRM. This means you can create leads, log activities, and use AI prompts even when on the go."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "What happens if I hit my prompt limit?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Pepper Cloud uses a credit-based system for AssistAI usage. Once you reach your prompt quota, you can easily top up to continue leveraging your AI assistant without interruption."
                                }
                            }
                        ],
                    },
                ]}
            />
            <section className={classes.commonHeroSection}>
                <section className={classes.heroSection}>
                    <div className='container'>
                        <div className={classes.heroSectionContainer}>
                            <motion.h1
                                initial={{ opacity: 1, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5 }}
                                className="font-wix-semibold font-white font-64"> AI assistant panel to elevate your CRM </motion.h1>
                            <motion.p initial={{ opacity: 1, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5 }} className='font-white font-wix-regular font-20'>Unlock smarter selling with Pepper Cloud AssistAI Panel, the AI assistant built to simplify your CRM, save time, and boost team productivity.</motion.p>
                            <Link to="/contact/" className="font-18 font-white font-wix-regular primaryButton">Book a free demo</Link>
                            <div className={classes.boxes}>
                                <div className={classes.box}>
                                    <img src={heroIcon1} alt="AssistAI panel by Pepper Cloud" />
                                    <p className="font-18 font-wix-medium font-white">
                                        Track sentiment trends across chats
                                    </p>
                                </div>
                                <div className={classes.box}>
                                    <img src={heroIcon2} alt="AI assistant panel in CRM" />
                                    <p className="font-18 font-wix-medium font-white">
                                        Prioritise follow-ups smartly
                                    </p>
                                </div>
                                <div className={classes.box}>
                                    <img src={heroIcon3} alt="AI virtual assistant for CRM tasks" />
                                    <p className="font-18 font-wix-medium font-white">
                                        Train your team using real interactions
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
            <section className={classes.heroSectionImgSection}>
                <div className='container'>
                    <img src={heroSectionImg2} alt="AI assistant panel in CRM" />
                </div>
            </section>
            <section className={clsx(classes.singleCardDetailsSection)}>
                <div className="container">
                    <div className={classes.singleCardDetails}>
                        <div className={classes.singleCardDetailsRight}>
                            <LazyImage
                                source={singleCardImg}
                                height={"100%"}
                                width={"100%"}
                                alt={"WhatsApp CRM for customer service"}
                                className={classes.singleCardDetailsRightImage}
                            />
                        </div>
                        <div className={classes.singleCardDetailsLeft}>
                            <motion.h2
                                initial={{ opacity: 1, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-semibold font-56 font-white"
                            >
                                Why do you need an AI assistant panel?
                            </motion.h2>
                            <motion.p
                                initial={{ opacity: 1, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-regular font-18 font-white mt20"
                            >
                                Without an AI assistant, teams waste hours on manual updates, tracking leads, or digging through data. Mistakes creep in, leads get missed, and productivity drops.
                            </motion.p>
                            <motion.p
                                initial={{ opacity: 1, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-regular font-18 font-white"
                            >
                                The AssistAI Panel changes this by letting your team type simple commands like “create a new lead for John Doe” or “show me today’s calls”. In return, it handles the work instantly, so your CRM feels as easy as chatting with a colleague.
                            </motion.p>
                        </div>
                    </div>
                    <motion.div
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className={classes.supportBox}
                    // style={{ background: point.background }}
                    >
                        <div className={classes.broadcastLeftContainer}>
                            <motion.h2
                                initial={{ opacity: 1, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-semibold font-56 font-white"
                            >
                                What is AI assistant panel?
                            </motion.h2>
                            <motion.p
                                initial={{ opacity: 1, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-regular font-18 font-white mt20"
                            >
                                The AI assistant panel is Pepper Cloud’s intelligent assistant that blends generative AI, assistive AI, and conversational AI. It understands natural commands, automates CRM tasks, suggests next steps, and retrieves data instantly. This smart layer of artificial intelligence turns complex processes into simple, human-like interactions, helping your team work faster and more accurately.
                            </motion.p>


                        </div>
                        <div className={classes.broadcastRightContainer}>
                            <LazyImage
                                source={broadcastImg}
                                height={"100%"}
                                width={"100%"}
                                alt={"CRM AI assistant dashboard"}
                                className={classes.broadcastImg}
                            />
                        </div>
                    </motion.div>
                </div>
            </section>
            <section className={classes.benefitSection1}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            What do teams expect from their AI virtual assistant?

                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-20 font-white"
                        >
                            Modern teams trust an AI virtual assistant to reduce routine work, suggest next actions, and deliver instant answers, all without complicated menus.
                        </motion.p>
                    </div>

                    <div className="benefits">
                        <div className="featureColumn">
                            <div className="featureContainer">
                                <LazyImage
                                    source={benefit1Icon1}
                                    alt={"Natural language prompts"}
                                    className={classes.featureIcon}
                                />
                                <p className="font-wix-semibold font-24 font-white">
                                    Natural language simplicity
                                </p>
                                <p className="font-wix-medium font-18 font-white">
                                    Type or click prompts just like speaking to a teammate.
                                </p>
                            </div>

                            <div className="featureContainer">
                                <LazyImage
                                    source={benefit1Icon2}
                                    alt={"Instant CRM actions"}
                                    className={classes.featureIcon}
                                />
                                <p className="font-wix-semibold font-24 font-white">
                                    Instant CRM actions
                                </p>
                                <p className="font-wix-medium font-18 font-white">
                                    Create leads, update contacts, add tasks, or fetch reports, instantly.
                                </p>
                            </div>
                        </div>

                        <div className="imageColumn">
                            <LazyImage
                                source={benefit1Img}
                                alt={"AI assistant automating CRM actions"}
                            // alt={listItem.alt}
                            />
                        </div>

                        <div className="featureColumn">
                            <div className="featureContainer">
                                <LazyImage
                                    source={benefit1Icon3}
                                    alt={"AI assistant panel in CRM"}
                                    className={classes.featureIcon}
                                />
                                <p className="font-wix-semibold font-24 font-white">
                                    Smart task automation
                                </p>
                                <p className="font-wix-medium font-18 font-white">
                                    Auto-create follow-ups, set reminders, and keep opportunities moving.
                                </p>
                            </div>

                            <div className="featureContainer">
                                <LazyImage
                                    source={benefit1Icon4}
                                    alt={"AssistAI panel by Pepper Cloud"}
                                    className={classes.featureIcon}
                                />
                                <p className="font-wix-semibold font-24 font-white">
                                    Real-time insights
                                </p>
                                <p className="font-wix-medium font-18 font-white">
                                    View pipeline updates, engagement stats, and next-best actions.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={classes.zigZagSection}>
                <div className='container'>
                    <div className={classes.zigZagContainer}>
                        <div className={classes.zigZagLeftContainer}>
                            <motion.h2
                                initial={{ opacity: 1, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-semibold font-56 font-white"
                            >
                                Why teams choose the AssistAI panel?
                            </motion.h2>
                            <motion.p
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-regular font-20 font-white"
                            >
                                Transforms daily CRM work, saves hours, and helps teams close more deals with intelligent automation
                            </motion.p>
                        </div>
                        <div className={classes.zigZagRightContainer}>
                            <div className={classes.zigZagBgCard}>
                                 <div className={clsx(classes.zigZagBox, 'regularCard')}>
                                <div className={classes.glowTop} />
                                <div className={classes.glowBottom} />
                                <p className='font-64 font-wix-semibold font-white'>60%</p>
                                <p className='font-18 font-wix-semibold font-white'>Faster deal cycles</p>
                            </div>
                            </div>
                            <div className={classes.zigZagBgCard}>
                            <div className={clsx(classes.zigZagBox, 'regularCard')}>
                                <div className={classes.glowTop} />
                                <div className={classes.glowBottom} />
                                <p className='font-64 font-wix-semibold font-white'>20+</p>
                                <p className='font-18 font-wix-semibold font-white'>Hours saved monthly</p>
                            </div>
                            </div>
                            <div className={classes.zigZagBgCard}>
                            <div className={clsx(classes.zigZagBox, 'regularCard')}>
                                <div className={classes.glowTop} />
                                <div className={classes.glowBottom} />
                                <p className='font-64 font-wix-semibold font-white'>100%</p>
                                <p className='font-18 font-wix-semibold font-white'>Pipeline visibility</p>
                            </div>
                            </div>
                            <div className={classes.zigZagBgCard}>
                            <div className={clsx(classes.zigZagBox, 'regularCard')}>
                                <div className={classes.glowTop} />
                                <div className={classes.glowBottom} />
                                <p className='font-64 font-wix-semibold font-white'>300%</p>
                                <p className='font-18 font-wix-semibold font-white'>Hours saved monthly</p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={classes.flipSection}>
                <div className="container">
                    <div className="centerContainer">
                        <h2 className="font-56 font-wix-medium font-white">
                            Why Pepper Cloud is the best CRM with an AI assistant
                        </h2>

                    </div>
                    <div
                        className={clsx(
                            classes.tabs,
                            tabsPastCards && classes.tabsScrolling,
                        )}
                    >
                        {flipCards.map((tab, index) => (
                            <div
                                key={tab.tab}
                                className={clsx(
                                    classes.fliptab,
                                    activeIndex === index && "active"
                                )}
                                onClick={() => {
                                    isManualScroll.current = true;
                                    setActiveIndex(index);

                                    const cards = document.querySelectorAll(
                                        "#flipCardsSection .card",
                                    );
                                    if (cards.length > 0 && cards[index]) {
                                        let cumulativeScrollPosition = 0;
                                        for (let i = 0; i < index; i++) {
                                            const cardHeight =
                                                cards[i].getBoundingClientRect().height;
                                            cumulativeScrollPosition += cardHeight;
                                        }
                                        const container =
                                            document.getElementById("flipCardsSection");
                                        const containerOffset = container
                                            ? container.getBoundingClientRect().top +
                                              window.pageYOffset
                                            : 0;
                                        const scrollPosition =
                                            containerOffset +
                                            cumulativeScrollPosition -
                                            280 + index * 36;
                                        window.scrollTo({
                                            top: scrollPosition,
                                            behavior: "smooth",
                                        });
                                    }

                                    setTimeout(() => {
                                        isManualScroll.current = false;
                                    }, 1000);
                                }}
                            >
                                <p className="font-18 sm:font-16 font-wix-regular font-white">
                                    {tab.tab}
                                </p>
                            </div>
                        ))}
                    </div>
                    <ul
                        id="flipCardsSection"
                        style={{ "--numcards": flipCards.length, paddingLeft: 0 }}
                    >
                        {flipCards.map((card, index) => (
                            <li
                                className="card"
                                id={`flip-card-${index}`}
                                key={card.tab}
                                style={{ "--index": index + 1 }}
                            >
                                <div
                                    className="card-content"
                                    style={{ background: card.background }}
                                >
                                    <div className="cardContentData">
                                        <h3 className="cardHeading font-wix-medium">
                                            {card.heading}
                                        </h3>
                                        <p className="cardDesciption">{card.desc}</p>
                                        {/* <Link
                                            to="/contact/"
                                            className="transparentButton font-wix-medium font-16 mt10"
                                        >
                                            {card.btnText}
                                        </Link> */}
                                    </div>
                                    <div className="cardImg">
                                        <LazyImage source={card.img} alt={card.alt} />
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                {/* <section className={classes.trustedSection}> */}
                <div className='container'>
                    <div className="trustedHeading">
                        <motion.h3
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-24 font-white"
                        >
                            Trusted by leading businesses for outstanding efficiency
                        </motion.h3>
                    </div>
                </div>
                <Swiper
                    className={classes.partnerSlider}
                    slidesPerView="auto"
                    spaceBetween={60}
                    loop={true}
                    speed={2000}
                    modules={[Autoplay]}
                    allowTouchMove={false}
                    autoplay={{
                        delay: 100,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                    }}
                >
                    {partners.map((partner) => (
                        <SwiperSlide className={classes.partnerSlide}>
                            <img src={partner.icon} alt={partner.alt} />
                        </SwiperSlide>
                    ))}
                </Swiper>
                {/* </section> */}
            </section>
            <section className={classes.tabsSection}>
                <div className={classes.absoulteCard}>
                    <TruestedSection shadow={true} background={true} />
                </div>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            Application and use cases of the AssistAI panel
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-20 font-white"
                        >
                            The AssistAi panel combines assistive AI, agentic AI, and conversational AI to streamline work. From sales to support, it automates tasks, provides insights, and keeps your team productive across every interaction.
                        </motion.p>
                        <div className={classes.tabsContainer}>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 0 && "active"
                                )}
                                onClick={() => setActiveRealWorld(0)}
                            >
                                Sales teams
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 1 && "active"
                                )}
                                onClick={() => setActiveRealWorld(1)}
                            >
                                Marketing teams
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 2 && "active"
                                )}
                                onClick={() => setActiveRealWorld(2)}
                            >
                                Support teams

                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 3 && "active"
                                )}
                                onClick={() => setActiveRealWorld(3)}
                            >
                                Business leaders
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 4 && "active"
                                )}
                                onClick={() => setActiveRealWorld(4)}
                            >
                                Remote teams
                            </div>
                        </div>
                    </div>
                    <div className={classes.tabCard}>
                        <div className={classes.tabCardLeftContainer}>
                            {tabContentData.map(
                                (listItem, index) =>
                                    index === activeRealWorld && (
                                        <div>
                                            <motion.p
                                                initial={{ opacity: 0, x: -20 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.3 }}
                                                className="font-wix-regular font-18 font-white"
                                            >
                                                {listItem.subtitle}
                                            </motion.p>
                                            <div className={classes.tabListContainer}>
                                                {listItem.tabContent.map((item) => (
                                                    <motion.div
                                                        initial={{ opacity: 0, x: -20 }}
                                                        whileInView={{ opacity: 1, x: 0 }}
                                                        transition={{ duration: 0.3 }}
                                                        className={classes.tabListItem}
                                                    >
                                                        <LazyImage
                                                            source={greenCheckCircle}
                                                            className={classes.tabIcon}
                                                            alt={item.alt}
                                                        />
                                                        <div className={classes.tabListItemContent}>
                                                            <p className="font-wix-semibold font-18 font-white">
                                                                {item.title}:
                                                            </p>
                                                            <p className="font-wix-regular font-18 font-white">
                                                                {item.content}
                                                            </p>
                                                        </div>
                                                    </motion.div>
                                                ))}
                                            </div>
                                        </div>
                                    )
                            )}
                        </div>
                        <div className={classes.tabCardRightContainer}>
                            {tabContentData.map(
                                (listItem, index) =>
                                    index === activeRealWorld && (
                                        <motion.div
                                            initial={{ opacity: 1, y: 20 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.3 }}
                                        // className={classes.aiSectionRight}
                                        >
                                            <LazyImage
                                                source={listItem.img}
                                                alt={listItem.alt}
                                                width={"100%"}
                                            />
                                        </motion.div>
                                    )
                            )}
                        </div>
                    </div>
                </div>
            </section>
            <TestimonialSlider desc={"Discover how businesses are transforming customer engagement with Pepper Cloud."} heading={"Real stories. Real results."} background={'#F8FCFF'} noButton={true} />

            <div className={classes.wpFaq}>
                <FaqSection
                    backgroundImage={faqBg}
                    dark={true}
                    heading={"AI assistant panel - frequently asked questions"}
                    faqs={faqs}
                />
            </div>
            <section className={classes.commonPageFooterSection}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            className="font-wix-medium font-56 font-white"
                            initial={{ opacity: 1, y: 30 }}
                            transition={{ duration: 0.5 }}
                            whileInView={{ opacity: 1, y: 0 }}
                        >
                            Email integration to supercharge your sales
                        </motion.h2>
                        <Link
                            className="primaryButton font-18 font-wix-medium font-white"
                            to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                            style={{padding:'8px 32px'}}
                        >
                            Get started
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default AiPanel